<template>
  <div class="return">
    <div class="return-top">
      <div class="return-top__name">退货单</div>
    </div>
    <div class="return-table">
      <Table :head="returnOrderTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { OrderNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'returnOrder',
  components: {
    Table
  },
  data(){
    return {
      returnOrderTableHead: OrderNewModule.NEWRETURNORDERTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.return{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
  }
}
</style>
